import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const FUELCONSUMPTIONTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.FuelConsumptionType.Name')
    .required()
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.FuelConsumptionType.Code')
    .required()
    .maxLength(10)
    .build(),
  FieldBuilder
    .checkbox('isManualDataEntry', 'Entity.FuelConsumptionType.IsManualDataEntry')
    .build(),
];

export const FUELCONSUMPTIONTYPE_CONFIG = {
  entityName: 'FuelConsumptionType',
  localizationKey: 'Controlling::Entity.FuelConsumptionType',
  fields: FUELCONSUMPTIONTYPE_FIELDS,
  permission: 'ControllingLiquidations.FuelConsumptionTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
